<!-- START OF SHOWN ONLY IN TABLET AND MOBILE VIEW -->
<ng-container *ngIf="isAnonymous || (data?.ranking?.adSpendRank &&
      data?.ranking?.adSpendRank !== 'N/A' &&
      data?.ranking?.category[0]?.rank && data?.ranking?.category[0]?.rank !== 'N/A'); else nodata">
  <div class="row mb-4 hidden-lg-up app-rankings mt-4">
    <div class="col-6">
      <h4>Popularity Rank</h4>
      <div class="ranking-num" enAnonLock>
        <img src="assets/images/rankings.svg" /> {{data?.ranking?.adSpendRank | num}}
      </div>
      <div>
        Programmatic Popularity Rank in {{selectedCountry?.label ? selectedCountry?.label: 'All Countries'}}
      </div>
    </div>
    <div class="col-5 border-left-1 pl-3" *ngIf="region !== 'GLOBAL' && data?.ranking?.regionRank !== 'N/A'">
      <h4>Region Rank</h4>
      <div class="ranking-num" enAnonLock>
        <img src="assets/images/rankings.svg" /> {{data?.ranking?.regionRank | num}}
      </div>
      <div>
        Region Rank in {{region === 'NA' ? 'North America' : region}}
      </div>
    </div>
    <div class="col-5"
      [ngClass]="{ 'border-left-1 pl-3': region === 'GLOBAL', 'mt-3': region !== 'GLOBAL' && data?.ranking?.regionRank !== 'N/A'}">
      <h4>Category Rank</h4>
      <div class="ranking-num" enAnonLock>
        <img src="assets/images/rankings.svg" /> {{data?.ranking?.category[0]?.rank | num}}
      </div>
      <div>
        Category Rank in {{data?.ranking?.category[0]?.category}}
      </div>
    </div>
  </div>
  <div class="row mb-4 publisher-scores hidden-lg-up">
    <div class="col">
      <div class="row">
        <div class="col">
          <h3 class="d-inline-block">Publisher Scores</h3>
          <div class="round-score text-center" enAnonLock enTooltip title="Final Score">
            {{data?.ranking?.final?.score}}
            <div class="rating">({{data?.ranking?.final?.grade}})</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col scores">
          <swiper #swiper style="width: 100%;" [slidesPerView]="3" [spaceBetween]="10" scrollbar=".swiper-scrollbar">
            <ng-template swiperSlide>
              <div class="publisher-score" *ngIf="data?.ranking?.popularity?.score">
                <div class="label">Popularity Score</div>
                <div class="value" enAnonLock>{{data?.ranking?.popularity?.score}}({{data?.ranking?.popularity?.grade}})
                </div>
              </div>
            </ng-template>
            <ng-template swiperSlide>
              <div class="publisher-score" *ngIf="data?.ranking?.ivt?.score">
                <div class="label">IVT Score</div>
                <div class="value" enAnonLock>{{data?.ranking?.ivt?.score}}({{data?.ranking?.ivt?.grade}})</div>
              </div>
            </ng-template>
            <ng-template swiperSlide *ngIf="data?.ranking?.brandSafety?.score">
              <div class="publisher-score">
                <div class="label">Brand Safety Score</div>
                <div class="value" enAnonLock>
                  {{data?.ranking?.brandSafety?.score}}({{data?.ranking?.brandSafety?.grade}})</div>
              </div>
            </ng-template>
            <ng-template swiperSlide *ngIf="data?.ranking?.adsTxt?.score">
              <div class="publisher-score">
                <div class="label">App-ads.txt Score</div>
                <div class="value" enAnonLock>{{data?.ranking?.adsTxt?.score}}({{data?.ranking?.adsTxt?.grade}})</div>
              </div>
            </ng-template>
            <ng-template swiperSlide *ngIf="data?.ranking?.viewability?.score">
              <div class="publisher-score">
                <div class="label">Viewability Score</div>
                <div class="value" enAnonLock>
                  {{data?.ranking?.viewability?.score}}({{data?.ranking?.viewability?.grade}})</div>
              </div>
            </ng-template>
            <ng-template swiperSlide *ngIf="data?.ranking?.permissions?.score">
              <div class="publisher-score">
                <div class="label">Permission Score</div>
                <div class="value" enAnonLock>
                  {{data?.ranking?.permissions?.score}}({{data?.ranking?.permissions?.grade}})</div>
              </div>
            </ng-template>
            <ng-template swiperSlide *ngIf="data?.ranking?.adDensity?.score">
              <div class="publisher-score">
                <div class="label">Ad Density</div>
                <div class="value" enAnonLock>{{data?.ranking?.adDensity?.score}}({{data?.ranking?.adDensity?.grade}})
                </div>
              </div>
            </ng-template>
            <ng-template swiperSlide *ngIf="data?.ranking?.dauMau?.score">
              <div class="publisher-score">
                <div class="label">DAU / MAU</div>
                <div class="value" enAnonLock>{{data?.ranking?.dauMau?.score}}({{data?.ranking?.dauMau?.grade}})</div>
              </div>
            </ng-template>
            <ng-template swiperSlide *ngIf="data?.ranking?.userEngagement?.score">
              <div class="publisher-score">
                <div class="label">Engagement Score</div>
                <div class="value" enAnonLock>
                  {{data?.ranking?.userEngagement?.score}}({{data?.ranking?.userEngagement?.grade}})
                </div>
              </div>
            </ng-template>
          </swiper>
          <div class="swiper-scrollbar js-swiper-scrollbar"></div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #nodata>
  <div class="row mb-4 no-data hidden-lg-up">
    <div class="col">
      <img src="assets/images/exclamation-warning-yellow.svg" /> Some data is not available for this app
    </div>
  </div>
</ng-template>

<div class="row badge-container hidden-lg-up">
  <div class="col" *ngIf="badges?.length > 0">
    <app-insight-badges class="d-flex" [data]="data" [badges]="badges"
      (anchorClick)="onAnchorClick($event)"></app-insight-badges>
  </div>
</div>
<!-- END OF SHOWN ONLY IN TABLET AND MOBILE VIEW -->

<div class="row information-cont">
  <div class="col-lg-7 description-container">
    <div class="heading">
      <div class="logo">
        <div class="img" *ngIf="data?.overview?.icon && data?.overview?.icon !== 'N/A'">
          <img class="app-details-logo-2" src="{{data?.overview?.icon}}" alt="CTV Details Logo" />
        </div>
        <div class="title-cont">
          <h1 class="title">
            {{data?.overview?.title}}
            <div class="dangerous-permissions-flag" *ngIf="hasDangerousPermissions">
              <i class="fa fa-exclamation-circle"></i>
              <span>dangerous permissions</span>
            </div>
          </h1>
          <div class="info-cont">
            <div class="info" [hidden]="loading">
              <div class='category'>
                <div class="label">Developer</div>
                <div class="value">
                  <ng-container *ngIf="_userService.ottDiscoveryEnabled()">
                    <a class="btn btn-link p-0"
                      (click)="goToDiscoveryClick({param: 'developerName', paramValue: data?.overview?.developerName})">
                      {{data?.overview?.developerName}}
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!_userService.ottDiscoveryEnabled()">
                    <span>{{data?.overview?.developerName}}</span>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="info" [hidden]="loading" *ngIf="data?.overview?.categories?.length > 0">
              <div class="category">
                <div class="label">Category</div>
                <div class="value">
                  <ng-container *ngIf="_userService.ottDiscoveryEnabled()">
                    <a class="btn btn-link p-0"
                      (click)="goToDiscoveryClick({param: 'category', paramValue: data?.overview?.categories[0].name})">
                      {{data?.overview?.categories[0].name}}
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!_userService.ottDiscoveryEnabled()">
                    {{data?.overview?.categories[0].name}}
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="flag-cont"
              *ngIf="data?.overview?.isChannelAggregator && data?.overview?.isChannelAggregator != 'N/A'">
              <div class="category appstore-flag">
                <a class="value channel-aggregator" (click)="goToSection('#app-channels')">
                  <img src="/assets/images/indicator-channel-aggregator.svg" alt="Indicator Channel Aggregator Icon" />
                  <span class="appstore-flag-label">Channel Aggregator</span>
                </a>
              </div>
              <div class="category appstore-flag d-none">
                <div class="value exists-{{data?.overview?.isExistInAppStore}}">
                  <i class="fa fa-check-circle" *ngIf="data?.overview?.isExistInAppStore" data-toggle="tooltip"
                    title="Checked within 15 minutes"></i>
                  <i class="fa fa-times-circle" *ngIf="!data?.overview?.isExistInAppStore" data-toggle="tooltip"
                    title="Checked within 15 minutes"></i>
                  <span class="appstore-flag-label">
                    {{data?.overview?.isExistInAppStore ? 'In' : 'Not in'}} {{ device === 'roku' ? 'Roku Store' : device
                    === 'firetv' ?
                    'FireTv Store' : device === 'samsung' ? 'Samsung Store' : 'tvOS Store'}}
                  </span>
                </div>
              </div>
              <div class="category appstore-flag d-none">
                <ng-container *ngIf="data?.overview?.hasAdsTxt">
                  <a class="value exists-{{data?.overview?.hasAdsTxt}}" target="_blank"
                    href="{{data?.overview?.adsTxtUrl | urlfix}}">
                    <i class="fa"
                      [ngClass]="{'fa-check-circle': data?.overview?.hasAdsTxt, 'fa-times-circle': !data?.overview?.hasAdsTxt}"></i>
                    <span class="appstore-flag-label">App-ads.txt</span>
                  </a>
                </ng-container>
                <ng-container *ngIf="!data?.overview?.hasAdsTxt">
                  <div class="value exists-{{data?.overview?.hasAdsTxt}} d-none">
                    <i class="fa"
                      [ngClass]="{'fa-check-circle': data?.overview?.hasAdsTxt, 'fa-times-circle': !data?.overview?.hasAdsTxt}"></i>
                    <span class="appstore-flag-label">App-ads.txt</span>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="info" [hidden]="loading"
              *ngIf="data?.appInfo?.starRatingCount && data?.appInfo?.starRatingCount !== 'N/A'">
              <div class="category">
                <div class="label">Rating</div>
                <div class="value" data-toggle="tooltip"
                  title="{{data?.appInfo?.starRatingCount | roundsig:'0a'}} ratings">
                  <i class="fa fa-star" *ngIf="data?.appInfo?.rating > 20"></i>
                  <i class="fa fa-star-o" *ngIf="data?.appInfo?.rating < 40"></i>
                  <i class="fa fa-star" *ngIf="data?.appInfo?.rating > 40"></i>
                  <i class="fa fa-star-o" *ngIf="data?.appInfo?.rating < 60"></i>
                  <i class="fa fa-star" *ngIf="data?.appInfo?.rating > 60"></i>
                  <i class="fa fa-star-o" *ngIf="data?.appInfo?.rating < 80"></i>
                  <i class="fa fa-star" *ngIf="data?.appInfo?.rating > 80"></i>
                  <i class="fa fa-star-o" *ngIf="data?.appInfo?.rating < 90"></i>
                  <i class="fa fa-star" *ngIf="data?.appInfo?.rating > 90"></i>
                </div>
              </div>
            </div>
            <div class="info" [hidden]="loading" *ngIf="data?.appInfo?.parentalHint">
              <div class="category">
                <div class="label">Parental Hint</div>
                <div class="value">
                  {{data?.appInfo?.parentalHint}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center mt-3">
        <div class="d-flex align-items-center mr-4">
          <ng-container>
            <button [disabled]="processingFollow" class="btn btn-primary" #followButton
              [class.btn-follow]="!isFollowing" [class.btn-unfollow]="isFollowing"
              (click)="followButtonClick.emit( $event )">
              <i class="fa fa-check mr-1" *ngIf="isFollowing"></i>
              <i class="fa fa-plus mr-1" *ngIf="!isFollowing"></i>
              {{ isFollowing ? "Following" : "Follow" }}
            </button>
          </ng-container>
          <ng-container *ngIf="!processingFollow && numWatching >=0">
            <label class="watching-count-label">{{numWatching}} Follower<span
                *ngIf="numWatching==0 || numWatching > 1">s</span></label>
          </ng-container>
          <ng-container *ngIf="processingFollow">
            <i style="position:relative;margin:0" class="fa fa-spin fa-spinner ml-2"></i>
          </ng-container>
        </div>
        <!-- <div class="viewcount-cont" *ngIf="viewCount >= 0">
          {{viewCount | num}} view<span *ngIf="viewCount>1">s</span>
        </div> -->
      </div>
    </div>

    <div *ngIf="data?.overview?.description && data?.overview?.description != 'N/A'"
      class="descriptionwrapper hidden-md-down">
      <pre>
        {{data?.overview?.description}}
      </pre>
      <ng-container *ngIf="data?.appInfo?.storeUrl !== 'N/A'">
        <div class="readmore" [hidden]="hideReadMoreLink">
          <div class="readmoretransparent"></div>
          <div class="readmoretext">
            <a class="btn btn-link" target="_blank" [attr.href]="data?.appInfo?.storeUrl | urlfix">
              Read more on the app store <i class="fa fa-external-link"></i>
            </a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="col-lg-5 screenshots-container" *ngIf="data?.overview?.screenshotUrls &&
      data?.overview?.screenshotUrls?.length > 0">
    <img class="current-image"
      [attr.src]="data?.overview?.screenshotUrls[currentScreenshotIndex] | screenshot:device:280"
      alt="Ctv Screenshot" />
    <div class="thumbnails">
      <a class="thumb-link" (click)="currentScreenshotIndex = k" [ngClass]="{active: currentScreenshotIndex === k}"
        *ngFor="let screenshot of data?.overview?.screenshotUrls; let k = index">
        <img [attr.src]="screenshot | screenshot:device:46" alt="CTV Screenshot Thumbnail" />
      </a>
    </div>
  </div>
</div>

<div class="row badge-container hidden-md-down">
  <div class="col" *ngIf="badges?.length > 0">
    <app-insight-badges [data]="data" class="d-flex" [badges]="badges"
      (anchorClick)="onAnchorClick($event)"></app-insight-badges>
  </div>
</div>

<div class="d-flex overview-rankings hidden-md-down" *ngIf="data?.ranking">
  <div class="overview-ranking-item">
    <div class="rank-heading">
      Programmatic Popularity Rank
      <a data-animation="false" data-placement="top" data-toggle="tooltip" entooltip=""
        title="Publisher Trust Index - Top Grossing Rank based on estimated programmatic spend">
        <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon">
      </a>
    </div>
    <div class="subheading">{{selectedCountry?.label}}</div>
    <div class="big-number-value" enAnonLock>{{data?.ranking?.adSpendRank | num}}</div>
  </div>
  <div class="overview-ranking-item" *ngIf="region !== 'GLOBAL'">
    <div class="rank-heading">
      Region Rank
      <a data-animation="false" data-placement="top" data-toggle="tooltip" entooltip=""
        title="Ranking of all apps monitored in a specific region within the Pixalate universe based on a range of
           Pixalate's most important metrics including: brand safety, IVT, MAU/DAU, IVT permission risks, and app-ads.txt">
        <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon">
      </a>
    </div>
    <div class="subheading">{{region === 'NA' ? 'North America' : region}}</div>
    <div class="big-number-value" enAnonLock>{{data?.ranking?.regionRank | num}}</div>
  </div>
  <div class="overview-ranking-item">
    <div class="rank-heading">
      Category Rank
    </div>
    <ng-container *ngIf="data?.ranking?.category">
      <div class="subheading">{{data?.ranking?.category[0]?.category}}</div>
      <div class="big-number-value" enAnonLock>{{data?.ranking?.category[0]?.rank | num}}</div>
    </ng-container>
    <ng-container *ngIf="!data?.ranking?.category">
      <div class="subheading">N/A</div>
      <div class="big-number-value">N/A</div>
    </ng-container>
  </div>
</div>